import { initializeApp } from "firebase/app";
import {
  createUserWithEmailAndPassword,
  getAuth,
  GoogleAuthProvider,
  updateProfile,
} from "firebase/auth";
import {
  getFirestore,
  collection,
  doc,
  addDoc,
  getDocs,
  updateDoc,
  getDoc,
  deleteDoc,
  arrayUnion,
  where,
  query,
  setDoc,
  serverTimestamp,
  Timestamp,
} from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

// ✅ Firebase config
const firebaseConfig = {
  // apiKey: "AIzaSyDNVyuOo6GMfpNg6rm1vS7dbSP-qAgS6cE",
  // authDomain: "hotel-scanner-78536.firebaseapp.com",
  // projectId: "hotel-scanner-78536",
  // storageBucket: "hotel-scanner-78536.appspot.com",
  // messagingSenderId: "642007673635",
  // appId: "1:642007673635:web:38d47c24961d9a769e3a96",
  // measurementId: "G-B66GR1L98E"
  apiKey: "AIzaSyDmQlc3mFJmQcWwEHpqoNFD5ugl-tJ0vno",
  authDomain: "tdcp-e4d8a.firebaseapp.com",
  projectId: "tdcp-e4d8a",
  storageBucket: "tdcp-e4d8a.firebasestorage.app",
  messagingSenderId: "733344221877",
  appId: "1:733344221877:web:f8f05b51e4bd2921e8ccfc",
  measurementId: "G-DHGPWS8CB8",
};

// ✅ Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app, "gs://tdcp-e4d8a.firebasestorage.app");
export const provider = new GoogleAuthProvider();

/** Sign-in with Email */
export const signInWithEmail = async (
  email,
  password,
  username,
  userRole,
  city,
  hotelId = null
) => {
  try {
    // 1. Create new user
    const userCredential = await createUserWithEmailAndPassword(
      auth,
      email,
      password
    );
    const user = userCredential.user;

    // 2. Update profile
    await updateProfile(user, { displayName: username });

    // 3. Send email verification
    // await sendEmailVerification(user);

    // 2️⃣ Prepare user data
    const userData = {
      id: user.uid,
      name: username,
      password: password,
      email,
      role: userRole,
      city,
      isActive: true,
      addedOn: serverTimestamp(),
    };
    // 4️⃣ If hotelId is passed, add it
    if (hotelId) {
      userData.hotelId = hotelId;
    }
    // 5️⃣ Save to Firestore
    await setDoc(doc(db, "users", user.uid), userData);

    return user;
  } catch (err) {
    console.error("Signup error:", err.code, err.message);
    throw err;
  }
};

/**
 * Upload image to Firebase Storage
 */

export const uploadImage = async (file, folder) => {
  if (!file) return null;
  const storageRef = ref(storage, `${folder}/${Date.now()}_${file.name}`);
  await uploadBytes(storageRef, file);
  return await getDownloadURL(storageRef);
};

/**
 * Add a new content document
 */
export const addContent = async (
  collectionName,
  folderName,
  data,
  imageFile
) => {
  try {
    let imageUrl = data.image || "";
    if (imageFile) {
      imageUrl = await uploadImage(imageFile, folderName);
    }
    const docRef = await addDoc(collection(db, collectionName), {
      ...data,
      image: imageUrl,
      createdAt: new Date(),
    });
    await updateDoc(docRef, { id: docRef.id });
    return { id: docRef.id, ...data, image: imageUrl };
  } catch (error) {
    console.error("Error adding content:", error);
    throw error;
  }
};

/**
 * Get all content documents
 */
export const getContents = async (collectionName) => {
  try {
    const querySnapshot = await getDocs(collection(db, collectionName));
    return querySnapshot.docs.map((docSnap) => ({
      id: docSnap.id,
      ...docSnap.data(),
    }));
  } catch (error) {
    console.error("Error fetching contents:", error);
    throw error;
  }
};

/**
 * Update a content document
 */
export const updateContent = async (
  collectionName,
  folderName,
  id,
  data,
  imageFile
) => {
  try {
    let imageUrl = data.image || "";
    if (imageFile) {
      imageUrl = await uploadImage(imageFile, folderName);
    }
    const docRef = doc(db, collectionName, id);
    await updateDoc(docRef, { ...data, image: imageUrl });
    return { id, ...data, image: imageUrl };
  } catch (error) {
    console.error("Error updating content:", error);
    throw error;
  }
};

/**
 * Delete a content document
 */
export const deleteContent = async (collectionName, id) => {
  try {
    await deleteDoc(doc(db, collectionName, String(id)));
    return true;
  } catch (error) {
    console.error("Error deleting content:", error);
    throw error;
  }
};

/** Add Hotel  */
export const addFHotel = async (collectionName, data) => {
  try {
    const docRef = await addDoc(collection(db, collectionName), {
      ...data,
      createdAt: new Date(),
    });
    return { id: docRef.id, ...data };
  } catch (error) {
    console.error("Error adding content:", error);
    throw error;
  }
};

/** get 30 Days date */

// 🔹 Next 30 days for table header
export const getNext30Days = () => {
  const days = [];
  const today = new Date();
  for (let i = 0; i < 30; i++) {
    const d = new Date(today);
    d.setDate(today.getDate() + i);
    days.push(d.toISOString().split("T")[0]);
  }
  return days;
};

// ✅ Get latest price for a given date
export const getPriceForDate = (inventory, date) => {
  const matches = inventory.filter(
    (u) => date >= u.startDate && date <= u.endDate
  );
  if (matches.length === 0) return "0";

  matches.sort((a, b) => b.priority?.seconds - a.priority?.seconds);
  return matches[0].price;
};
// ======================= SUB CONTENT FUNCTIONS =======================

/** -------------------------
 * SUBCOLLECTION HELPERS
 * ------------------------- */

// 🔹 Plans (subcollection under rooms)
export const getRoomPlans = async (roomId) => {
  // const q = query(
  //   collectionGroup(db, "plans"),
  //   where("roomId", "==", roomId)
  // );

  // const snapshot = await getDocs(q);
  // return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  const plansRef = collection(db, "hotel_rooms", roomId, "plans");
  const snapshot = await getDocs(plansRef);
  return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
};

export const addPlanToRoom = async (roomId, plan) => {
  try {
    const ref = collection(doc(db, "hotel_rooms", String(roomId)), "plans");
    const res = await addDoc(ref, plan);

    // also update parent doc with reference to the plan
    await updateDoc(doc(db, "hotel_rooms", String(roomId)), {
      plans: arrayUnion(res.id), // keeps track of plan IDs
    });

    console.log("✅ Plan added successfully:", res.id, plan);
    return res.id;
  } catch (error) {
    console.error("❌ Error adding plan to room:", error, { roomId, plan });
    throw error;
  }
};

export const updatePlanInRoom = async (roomId, planId, plan) => {
  console.log(roomId, planId, plan);
  try {
    // reference: hotel_rooms/{roomId}/plans/{planId}
    const ref = doc(db, "hotel_rooms", String(roomId), "plans", String(planId));
    await updateDoc(ref, plan);
    console.log("✅ Plan updated successfully:", planId, plan);
    return true;
  } catch (error) {
    console.error("❌ Error updating plan in room:", error, {
      roomId,
      planId,
      plan,
    });
    throw error;
  }
};

export const deletePlanFromRoom = async (roomId, planId) => {
  const planRef = doc(db, "hotel_rooms", roomId, "plans", planId);
  await deleteDoc(planRef);
};

export const getAvailableHotels = async (checkIn, checkOut) => {
  try {
    const hotelsCollection = collection(db, "hotels");
    // Query for hotels that have the checkIn and checkOut fields within the provided range
    const q = query(
      hotelsCollection,
      where("checkIn", "<=", checkIn),
      where("checkOut", ">=", checkOut),
      where("isApproved", "==", true)
    );

    const hotelsSnapshot = await getDocs(q);
    // Map over the documents to get the data
    const hotelList = hotelsSnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    //console.log("firebase hotels:", hotelList);
    return hotelList;
  } catch (error) {
    console.error("Error fetching hotels by date: ", error);
    throw error;
  }
};

export const getAvailableRooms = async (hotel_id, checkIn, checkOut) => {
  console.log("getting available rooms:");
  try {
    const roomsRef = collection(db, "hotel_rooms");
    const q = query(
      roomsRef,
      where("hotel_id", "==", hotel_id),
      where("isApproved", "==", true)
    );

    const querySnapshot = await getDocs(q);
    //console.log(querySnapshot)
    let rooms = [];
    const reservationsRef = collection(db, "reservations");
    const reservationQuery = query(
      reservationsRef,
      where("hotelId", "==", hotel_id),
      where("checkIn", "<=", checkOut),
      where("checkOut", ">=", checkIn)
    );
    const reservationSnapshot = await getDocs(reservationQuery);

    for (let roomDoc of querySnapshot.docs) {
      let room = { id: roomDoc.id, ...roomDoc.data() };
      //console.log("Room data:", room);

      const plansRef = collection(doc(db, "hotel_rooms", room.id), "plans");
      const plansQuery = query(plansRef, where("stopSell", "==", false));
      const plansSnapshot = await getDocs(plansQuery);
      const availablePlans = [];

      for (const planDoc of plansSnapshot.docs) {
        const plan = { id: planDoc.id, ...planDoc.data() };
        let reservedQuantity = 0;

        reservationSnapshot.forEach((resDoc) => {
          const reservation = resDoc.data();
          //console.log(reservation);

          // Convert check-in and check-out to Date objects
          const resCheckInDate = new Date(reservation.checkIn);
          const resCheckOutDate = new Date(reservation.checkOut);
          const userCheckInDate = new Date(checkIn);
          const userCheckOutDate = new Date(checkOut);

          // Only check overlap if the reservation's check-out is after the user's check-in date
          // and the reservation's check-in is before the user's check-out
          const isOverlapping =
            resCheckInDate < userCheckOutDate &&
            resCheckOutDate > userCheckInDate;

          if (isOverlapping) {
            reservedQuantity += reservation.roomDetails.reduce(
              (acc, detail) => {
                return detail.id === room.id && detail.planId === plan.id
                  ? acc + detail.quantity
                  : acc;
              },
              0
            );
          }
        });

        //console.log("Reserved Quantity for plan:", reservedQuantity);

        const availableQuantity = plan.totalPlan - reservedQuantity;

        // Only add plans with positive availability
        if (availableQuantity > 0) {
          // Call getRatePlanPrice to get the rate plan price
          const { totalAmount, nightlyPrices } = await getRatePlanPrice(
            hotel_id,
            room.id,
            plan.id,
            checkIn,
            checkOut
          );
          availablePlans.push({
            ...plan,
            availableQuantity,
            price: totalAmount,
            nightlyPrices,
            quantityLeft: availableQuantity,
          });
        }
      }

      if (availablePlans.length > 0) {
        room.plans = availablePlans;
        rooms.push(room);
      }
    }

    return rooms;
  } catch (error) {
    console.error("Error fetching rooms: ", error);
    return [];
  }
};

// --------------------------To get RatePlan Price------------------------

const getRatePlanPrice = async (
  hotel_id,
  room_id,
  rateplan_id,
  checkIn,
  checkOut
) => {
  try {
    //console.log("Input Data:", hotel_id, room_id, rateplan_id, checkIn, checkOut);

    // Convert checkIn and checkOut to Date objects
    const checkInDate = new Date(checkIn);
    const checkOutDate = new Date(checkOut);

    if (isNaN(checkInDate) || isNaN(checkOutDate)) {
      throw new Error("Invalid check-in or check-out date.");
    }

    const inventoryRef = collection(db, "inventory");
    let totalAmount = 0;
    let nightlyPrices = [];

    // Query to fetch all records for the specified hotel, room, and rate plan
    const inventoryQuery = query(
      inventoryRef,
      where("hotel_id", "==", hotel_id),
      where("room_id", "==", room_id),
      where("rateplan_id", "==", rateplan_id)
    );

    const inventorySnapshot = await getDocs(inventoryQuery);
    if (inventorySnapshot.empty) {
      console.log("No matching records found.");
      return 0; // No records found
    }

    // Loop through each night between check-in and check-out (excluding check-out)
    for (
      let currentDate = new Date(checkInDate);
      currentDate < checkOutDate;
      currentDate.setDate(currentDate.getDate() + 1)
    ) {
      // Convert currentDate to a proper Date object (since setDate mutates the original object)
      const nightDate = new Date(currentDate);

      // Find the highest priority price for this specific night
      let highestPriorityPrice = null;
      inventorySnapshot.forEach((doc) => {
        const inventory = doc.data();
        //console.log("Inventory Record:", inventory);
        // Convert startDate and endDate to Date objects
        const startDate =
          inventory.startDate instanceof Timestamp
            ? inventory.startDate.toDate()
            : new Date(inventory.startDate);
        const endDate =
          inventory.endDate instanceof Timestamp
            ? inventory.endDate.toDate()
            : new Date(inventory.endDate);

        // Check if the inventory is applicable for this specific night
        const isApplicable = startDate <= nightDate && endDate >= nightDate;

        if (isApplicable) {
          //console.log(`Applicable Inventory Record for date ${nightDate.toISOString().split("T")[0]}:`, inventory);
          // If there's only one record or a new record has a higher priority
          if (
            highestPriorityPrice === null ||
            inventory.priority > highestPriorityPrice.priority
          ) {
            highestPriorityPrice = {
              price: inventory.price,
              priority: inventory.priority,
            };
          }
        }
      });

      // Add the price for the current night to the total amount and push it to nightlyPrices array
      if (highestPriorityPrice) {
        totalAmount += highestPriorityPrice.price;
        nightlyPrices.push({
          date: nightDate.toISOString().split("T")[0],
          price: highestPriorityPrice.price,
        });
        //console.log(`Price for date ${nightDate.toISOString().split("T")[0]}: ${highestPriorityPrice.price}`);
      } else {
        console.log(
          `No applicable price found for date: ${
            nightDate.toISOString().split("T")[0]
          }`
        );
      }
    }

    //console.log("Total Amount for the Stay:", totalAmount);
    return { totalAmount, nightlyPrices };
  } catch (error) {
    console.error("Error fetching rate plan price:", error);
    return { totalAmount: 0, nightlyPrices: [] };
  }
};

// -------------Get Firebase  Promos----------------

export const getPromosData = async (checkin, checkout) => {
  try {
    const promotionsCollection = collection(db, "promotions");
    const snapshot = await getDocs(promotionsCollection);
    const promosData = snapshot.docs
      .map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }))
      .filter((promo) => {
        const promoStartDate = new Date(promo.startDate);
        const promoEndDate = new Date(promo.endDate);
        const checkinDate = new Date(checkin);
        const checkoutDate = new Date(checkout);

        // Check if promo dates encompass checkin and checkout dates
        return (
          promo.active &&
          promoStartDate <= checkinDate &&
          promoEndDate >= checkoutDate
        );
      });

    return promosData;
  } catch (error) {
    console.error("Error fetching promotions:", error);
    return [];
  }
};

/** =========================
 * HOTEL WISE SERVICES / PRODUCTS
 * ========================= */

/** 🔹 Get all hotels */
export const getAllHotels = async () => {
  try {
    const snap = await getDocs(collection(db, "hotels"));
    return snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  } catch (err) {
    console.error("Error fetching hotels:", err);
    return [];
  }
};

/** 🔹 Get all services for a hotel */
export const getHotelServices = async (hotelId) => {
  try {
    const snap = await getDocs(collection(db, "hotels", hotelId, "services"));
    return snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  } catch (err) {
    console.error("Error fetching services:", err);
    return [];
  }
};

/** 🔹 Add service */
export const addHotelService = async (hotelId, data, imageFile) => {
  try {
    let imageUrl = "";
    if (imageFile) {
      imageUrl = await uploadImage(imageFile, "services");
    }

    const ref = await addDoc(collection(db, "hotels", hotelId, "services"), {
      ...data,
      image: imageUrl,
      createdAt: new Date(),
    });

    await updateDoc(ref, { id: ref.id });

    return { id: ref.id, ...data, image: imageUrl };
  } catch (err) {
    console.error("Error adding Service:", err);
    throw err;
  }
};

/** 🔹 Update service */
export const updateHotelService = async (hotelId, id, data, imageFile) => {
  try {
    let imageUrl = data.image || "";
    if (imageFile) {
      imageUrl = await uploadImage(imageFile, "services");
    }

    await updateDoc(doc(db, "hotels", hotelId, "services", id), {
      ...data,
      image: imageUrl,
    });

    return { id, ...data, image: imageUrl };
  } catch (err) {
    console.error("Error updating Service:", err);
    throw err;
  }
};

/** 🔹 Delete service */
export const deleteHotelService = async (hotelId, id) => {
  try {
    await deleteDoc(doc(db, "hotels", hotelId, "services", id));
    return true;
  } catch (err) {
    console.error("Error deleting Service:", err);
    throw err;
  }
};

/** 🔹 Get products for hotel */
export const getHotelProducts = async (hotelId) => {
  try {
    const snap = await getDocs(collection(db, "hotels", hotelId, "products"));
    return snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  } catch (err) {
    console.error("Error fetching products:", err);
    return [];
  }
};

/** 🔹 Add product */
export const addHotelProduct = async (hotelId, data, imageFile) => {
  try {
    let imageUrl = "";
    if (imageFile) {
      imageUrl = await uploadImage(imageFile, "products");
    }

    const ref = await addDoc(collection(db, "hotels", hotelId, "products"), {
      ...data,
      image: imageUrl,
      createdAt: new Date(),
    });

    await updateDoc(ref, { id: ref.id });

    return { id: ref.id, ...data, image: imageUrl };
  } catch (err) {
    console.error("Error adding Product:", err);
    throw err;
  }
};

/** 🔹 Update product */
export const updateHotelProduct = async (hotelId, id, data, imageFile) => {
  try {
    let imageUrl = data.image || "";
    if (imageFile) {
      imageUrl = await uploadImage(imageFile, "products");
    }

    await updateDoc(doc(db, "hotels", hotelId, "products", id), {
      ...data,
      image: imageUrl,
    });

    return { id, ...data, image: imageUrl };
  } catch (err) {
    console.error("Error updating Product:", err);
    throw err;
  }
};

/** 🔹 Delete product */
export const deleteHotelProduct = async (hotelId, id) => {
  try {
    await deleteDoc(doc(db, "hotels", hotelId, "products", id));
    return true;
  } catch (err) {
    console.error("Error deleting Product:", err);
    throw err;
  }
};
// Fetch single reservation by ID
export const getReservationById = async (id) => {
  const docRef = doc(db, "reservations", id);
  const snap = await getDoc(docRef);
  if (snap.exists()) {
    return { id: snap.id, ...snap.data() };
  }
  return null;
};

export const getHotelById = async (id) => {
  if (!id) return null;
  const docRef = doc(db, "hotels", id);
  const snap = await getDoc(docRef);
  if (snap.exists()) {
    return { id: snap.id, ...snap.data() };
  }
  return null;
};

export const resolveHotelImage = (hotel, fallbackImage = "") => {
  if (fallbackImage) return fallbackImage;
  if (!hotel) return "";
  if (hotel.image) return hotel.image;
  const gallery = hotel.gallery || [];
  if (!gallery.length) return "";
  const first = gallery[0];
  return typeof first === "string" ? first : first?.url || "";
};
